import { jsx as e, jsxs as g, Fragment as j } from "react/jsx-runtime";
import { makeClassesByStyles as k } from "../../../../utils/classes.js";
import { GradientBorderWrapper as w } from "../../../gradient-border-wrapper/gradient-border-wrapper.js";
import { Icon as p } from "../icon/icon.js";
import { Image as I } from "../image/image.js";
import { Loader as v } from "../loader/loader/loader.js";
import f from "../../../../assets/f1ac8584.button.module.css";
const r = k(f), D = ({
  asset: s,
  children: h,
  className: u = "",
  color: m = "secondary",
  handleClick: N,
  icon: a,
  iconAlignment: t = "left",
  isDisabled: $,
  isLoading: l,
  size: b = "md",
  styledAs: c = "button",
  text: o,
  type: y = "button",
  ariaPressed: B,
  withGradientBorder: i = !1,
  // Default value
  borderRadius: n,
  ...x
}) => {
  const C = r(
    "Button",
    `--as-${c}`,
    `--${m}`,
    `--${b}`,
    `--${n}`,
    { "--with-image": !!s },
    u
  ), d = /* @__PURE__ */ e(
    "button",
    {
      className: C,
      disabled: $ || l,
      onClick: N,
      type: y,
      "aria-pressed": B,
      ...x,
      children: l ? /* @__PURE__ */ e(v, { className: r("loader") }) : /* @__PURE__ */ g(j, { children: [
        (a == null ? void 0 : a.name) && (t === "standalone" || t === "left") && /* @__PURE__ */ e(p, { className: r(`icon-alignment-${t}`), name: a.name }),
        !!s && /* @__PURE__ */ e(
          I,
          {
            className: f.asset,
            alt: o ?? "",
            src: s,
            width: 32,
            height: 32
          }
        ),
        /* @__PURE__ */ e("span", { className: "relative z-10", children: o }),
        h,
        (a == null ? void 0 : a.name) && t === "right" && /* @__PURE__ */ e(p, { className: r(`icon-alignment-${t}`), name: a.name })
      ] })
    }
  );
  return i ? /* @__PURE__ */ e(w, { color: m, borderRadius: n, children: d }) : d;
};
export {
  D as Button
};
